

























































































import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import { GameStore } from "@/stores/GameStore";
import { HTMLColor } from "@/classes/HTMLColor";
import { DeckConfig } from "@/interfaces/Deck";
import { RoomConfig } from "@/classes/RoomConfig";

@Component
export default class DeckConfigEditor extends Vue {
  @Prop(GameStore) readonly gameStore!: GameStore;
  private localConfig: DeckConfig = Object.assign(
    {},
    this.gameStore.roomConfig.deckConfig
  );

  get faceCollections() {
    return this.localConfig.cardFaces;
  }
  get colorCollections() {
    return this.localConfig.cardColors;
  }
  get commaSeparatedFaceCollections() {
    const seperatedCollections: Array<string> = [];
    this.faceCollections.forEach((collection) => {
      let values = "";
      collection.forEach((face) => {
        values += face + ",";
      });
      seperatedCollections.push(values);
    });
    return seperatedCollections;
  }

  addColor(collectionIndex: number) {
    this.colorCollections[collectionIndex].push(new HTMLColor(1, 1, 1));
  }

  addCollection() {
    this.localConfig.cardFaces.push([]);
    this.localConfig.cardColors.push([]);
  }

  handleInput(e: InputEvent, collectionIndex: number) {
    const target = e.target as HTMLInputElement;
    this.localConfig.cardFaces[collectionIndex] = target.value.split(",");
  }

  handleColorPicker(e: Event, collectionIndex: number, colorIndex: number) {
    const target = e.target as HTMLInputElement;
    this.localConfig.cardColors[collectionIndex][
      colorIndex
    ] = HTMLColor.fromHex(target.value) as HTMLColor;
  }

  @Emit("hide-config")
  save() {
    this.gameStore.setRoomConfig(
      new RoomConfig(
        this.localConfig,
        this.gameStore.roomConfig.numberOfPlayers
      )
    );
  }

  hide() {
    const htmlElement = document.getElementsByClassName(
      "deckConfig"
    )[0] as HTMLElement;
    htmlElement.style.display = "none";
  }

  removeCollection(collectionIndex: number) {
    this.localConfig.cardFaces.splice(collectionIndex);
    this.localConfig.cardColors.splice(collectionIndex);
  }
}
